import React, { useState, useEffect } from 'react';
import {NavLink,Link } from 'react-router-dom';
import { useAuth } from '../../context/auth';
import toast from 'react-hot-toast';
import SearchInput from '../Form/SearchInput';
import useCategory from '../../hooks/useCategory';
import { useCart } from '../../context/cart';
import {Badge} from 'antd';

const Header = () => {
  const [auth, setAuth ] = useAuth();
  const [cart] = useCart();
  const categories = useCategory();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = () =>{
    setAuth({
      ...auth,
      user:null,
      token:"",
    });
    localStorage.removeItem('auth');
    toast.success("تم تسجيل الخروج بنجاح");
  };
  return (
    <>
       <nav className={`navbar navbar-expand-lg ${scrolled ? 'navbar-scrolled' : ''}`}>
  <div className="container-fluid">
    <Link to="/" className="navbar-brand">
      <div className="nav-logo-wrapper">
        <img src="/images/logo1.jpeg" alt="النخبة ستور" className="nav-logo" />
      </div>
      <div className="nav-brand-text">
        <span className="nav-brand-name">النخبة ستور</span>
        <span className="nav-brand-tagline">عنوان الفخامة</span>
      </div>
    </Link>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="القائمة">
      <span className="navbar-toggler-icon" />
    </button>
    <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <SearchInput />
        <li className="nav-item">
          <NavLink to="/" className="nav-link">الرئيسية</NavLink>
        </li>

       <li className="nav-item dropdown">
  <Link className="nav-link dropdown-toggle" to={"/categories"} data-bs-toggle="dropdown">
    الأقسام
  </Link>
     <ul className="dropdown-menu">
     <li>
      <Link className="dropdown-item" to={"/categories"}>
        جميع الأقسام
      </Link>
      </li>
     {categories?.map((c) => (
     <li key={c._id}>
      <Link className="dropdown-item" to={`/category/${c.slug}`}>{c.name}
      </Link>
      </li>
  ))}
  </ul>
</li>

        {/* Admin access only */}
        {auth?.user?.role === 1 && (
          <li className="nav-item dropdown">
            <NavLink
              className="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              {auth?.user?.name}
            </NavLink>
            <ul className="dropdown-menu">
              <li>
                <NavLink to="/dashboard/admin" className="dropdown-item">
                  لوحة التحكم
                </NavLink>
              </li>
              <li>
                <NavLink onClick={handleLogout} to="/login" className="dropdown-item">تسجيل الخروج</NavLink>
              </li>
            </ul>
          </li>
        )}

        <li className="nav-item">
        <Badge count={cart?.length} showZero>
        <NavLink to="/cart" className="nav-link">
          السلة</NavLink>
    </Badge>
        </li>
      </ul>
     </div>
  </div>
</nav>
    </>
  );
};

export default Header;
